/* eslint-disable */
import React, { useEffect, useContext } from "react";
import { WebSocketContext } from "../../../App";
import wsSend_request from "../../../Api/ws/ws_request";
import { useSelector, useDispatch } from "react-redux";
import CommonDateTime from "../../Common/CommonDateTime";
import { FRANCHISE_DISPATCH_URL } from "../../Shared/constant";
import {
  updateOrderManagementFilter,
  ClearFormSetFutios,
} from "../../../redux/actions/adminActions";
import MainOrderDataTableFilter from "../../Common/MainOrderDataTableFilter";
import CommonTable from "../../Common/CommonTable";

const FranchiseDispatch = (props) => {
  const Dispatch = useDispatch();
  const { websocket } = useContext(WebSocketContext);
  const {
    device_id,
    PendingForStoresList,
    ClearFormSet,
    sortingfor,
    selfInfo,
    OrderManagmentFilter,
  } = useSelector((state) => state.adminReducers);
  const PermissionsAccess = selfInfo?.user?.permissions_access;

  // page change
  const currentFunction = (page) => {
    Dispatch(
      updateOrderManagementFilter({
        PendingForStores: {
          CurrentPage: page,
        },
      })
    );
  };

  // get all product list
  useEffect(() => {
    let param = {
      transmit: "broadcast",
      url: "product_list",
      request: {
        status: true,
        limit: 5000,
        page_no: 1,
        search: "",
      },
      DeviceId: device_id,
    };
    wsSend_request(websocket, param);
  }, [websocket]);

  // get all warehouse list
  useEffect(() => {
    let param = {
      transmit: "broadcast",
      url: "warehouse_list",
      request: {
        status: "",
        limit: 5000,
        page_no: 1,
        search: "",
      },
      DeviceId: device_id,
    };
    wsSend_request(websocket, param);
  }, [websocket]);

  // get all region list
  useEffect(() => {
    let param = {
      transmit: "broadcast",
      url: "region_list",
      request: {
        status: "",
        limit: 5000,
        page_no: 1,
        search: "",
      },
      DeviceId: device_id,
    };
    wsSend_request(websocket, param);
  }, [websocket]);

  // order list api calling
  const APICall = () => {
    const {
      UserLimit,
      UserSearch,
      SelectDateType,
      SelectRegion,
      OrderSource,
      FromDate,
      ToDate,
      CurrentPage,
      WarehouseName,
      ProductName,
      is_bundle_orders,
      is_odi_courier_pin,
      PreBookFilter,
    } = OrderManagmentFilter?.PendingForStores;

    let param = {
      transmit: "broadcast",
      url: "order_list",
      request: {
        status: "AC_APPROVED,WH_APPROVED",
        limit: UserLimit,
        page_no: CurrentPage,
        search: UserSearch.trim(),
        from_date: null,
        to_date: null,
        from_inv: null,
        to_inv: null,
        from_updated_date: null,
        to_updated_date: null,
        order_type: OrderSource,
        region_id: SelectRegion,
        is_ac_approved: true,
        order_by: sortingfor,
        fetch_location_info: true,
        is_bundle_orders: is_bundle_orders,
        pin_code_flag: is_odi_courier_pin?.flag,
      },
      DeviceId: device_id,
    };

    if (SelectDateType === "created_at") {
      if (FromDate !== "" && ToDate !== "") {
        param.request.from_date = CommonDateTime(
          FromDate,
          "YYYY-MM-DD",
          "hide"
        );
        param.request.to_date = CommonDateTime(ToDate, "YYYY-MM-DD", "hide");
      }
    } else {
      if (FromDate !== "" && ToDate !== "") {
        param.request.from_updated_date = CommonDateTime(
          FromDate,
          "YYYY-MM-DD",
          "hide"
        );
        param.request.to_updated_date = CommonDateTime(
          ToDate,
          "YYYY-MM-DD",
          "hide"
        );
      }
    }

    if (WarehouseName) {
      param.request.warehouse_id = WarehouseName?.map(
        (elm) => elm?.value
      )?.toString();
    }

    if (ProductName) {
      param.request.product_id = ProductName?.map(
        (elm) => elm?.value
      )?.toString();
    }

    if (PreBookFilter === "true" || PreBookFilter === "false") {
      param.request.pre_book = PreBookFilter === "true";
    }

    wsSend_request(websocket, param);
  };

  useEffect(() => {
    APICall();
  }, [websocket, OrderManagmentFilter?.PendingForStores]);

  useEffect(() => {
    if (sortingfor !== "" && sortingfor !== "-") {
      APICall();
    }
  }, [sortingfor]);

  useEffect(() => {
    if (ClearFormSet?.action === 200) {
      Dispatch(
        ClearFormSetFutios({
          url: "",
          action: false,
        })
      );
      APICall();
    }
  }, [ClearFormSet]);

  // TABLE COLUMNS ARRAY
  const TableColumns = [
    {
      key: "order_code",
      label: "Order Id.",
      type: "navigate_regular_order",
      navigate_url: FRANCHISE_DISPATCH_URL,
      sort: "order_code",
      isCollapsable: false,
    },
    {
      key: "erp_id",
      label: "ERP Order Code",
      type: "label",
      sort: "",
      isCollapsable: false,
    },
    {
      key: "customer_identity",
      label: "Customer Code",
      type: "label",
      sort: "customer_identity",
      isCollapsable: false,
    },
    {
      key: "created_at",
      label: "Order Date",
      type: "date",
      sort: "created_at",
      isCollapsable: false,
    },
    {
      key: "updated_at",
      label: "Updated Date",
      type: "date",
      sort: "updated_at",
      isCollapsable: false,
    },
    {
      key: "customer_name",
      label: "SHIP To Name",
      type: "label",
      sort: "customer_name",
      isCollapsable: false,
    },
    {
      key: "pin_code",
      label: "SHIP Pincode",
      type: "label",
      sort: "pin_code_id",
      isCollapsable: false,
    },
    {
      key: "state",
      label: "SHIP State",
      type: "label",
      sort: "state_id",
      isCollapsable: false,
    },
    {
      key: "district",
      label: "SHIP City",
      type: "label",
      sort: "district_id",
      isCollapsable: false,
    },
    {
      key: "billing_id",
      label: "BILL To Name",
      type: "label_get_from_franchise",
      sort: "billing_id",
      isCollapsable: false,
    },
    {
      key: "",
      label: "Old Warehouse",
      type: "label_old_warehouse",
      sort: "",
      isCollapsable: false,
    },
    {
      key: "warehouse_id",
      label: "Ship From Warehouse",
      type: "label_get_ship_warehouse",
      sort: "",
      isCollapsable: false,
    },
    {
      key: "qty",
      label: "Quantity",
      type: "label",
      sort: "qty",
      isCollapsable: false,
    },
    {
      key: "order_priority",
      label: "Order Priority",
      type: "label",
      sort: "order_priority",
      isCollapsable: false,
    },
    {
      key: "total",
      label: "Order Value",
      type: "label_day_ammount",
      sort: "total",
      isCollapsable: false,
    },
    {
      key: "priority",
      label: "Criticality",
      type: "label_Criticality",
      sort: "priority",
      isCollapsable: false,
    },
    {
      key: "is_automated",
      label: "Automated",
      type: "status_yes_no",
      sort: "",
      isCollapsable: false,
    },
    {
      key: "erp_id",
      label: "ERP Api Status",
      type: "label_erp_invoice_delivery_note_api_status",
      sort: "",
      isCollapsable: false,
    },
    {
      key: "so_outstanding_breached",
      label: "SO Outstanding Breached",
      type: "status_yes_no",
      sort: "",
      isCollapsable: false,
    },
    {
      key: "uni_ful_fillment_tat",
      label: "Fulfillment TAT",
      type: "fulfillment_tat",
      sort: "",
      isCollapsable: false,
    },

    {
      key: "updated_at",
      label: "Pending Since",
      type: "pending_since",
      sort: "updated_at",
      isCollapsable: false,
    },
    {
      key: "warehouse_remark",
      label: "Remarks",
      type: "label",
      sort: "",
      isCollapsable: false,
    },
    {
      key: "order_source",
      label: "Order Source",
      type: "label",
      sort: "",
      isCollapsable: true,
    },
    {
      key: "category",
      label: "SKU Type",
      type: "label",
      sort: "",
      isCollapsable: true,
    },
    {
      key: "order_status",
      label: "Status",
      type: "label_order_status",
      sort: "",
      isCollapsable: true,
    },
    { key: "", label: "", type: "Attachments", sort: "", isCollapsable: true },
    {
      key: "region_id",
      label: "Region",
      type: "label_get_from_list",
      filterFrom: { list: "regionlist", label: "region_name" },
      sort: "",
      isCollapsable: true,
    },
  ];

  return (
    <section className="Main_section">
      <MainOrderDataTableFilter
        filterType={""}
        tabName={"PendingForStores"}
        searchType={"Order Id, ERP Order Code, Name, Invoice ID, Customer Code"}
        FromDateStartDateFlag={true}
        searchdisable={true}
        buttonvisible={false}
        AllOrderStatusAllow={false}
        isAllowWarehouse={true}
        isAllowProduct={true}
        isDateType={true}
        isOdiFilterAllow={true}
        isRegionAllow={true}
        isBundleOrdersAllow={true}
        isOrderSourceAllow={true}
        isPreBookFilterAllow={true}
      />
      {/* COMMON TABLE */}
      <CommonTable
        isTableAllow={true}
        style={{
          height:
            parseInt(PendingForStoresList?.pagination?.total_records) ===
            PendingForStoresList?.list?.length
              ? "calc(100vh - 196px)"
              : parseInt(PendingForStoresList?.pagination?.total_records) > 10
              ? "calc(100vh - 235px)"
              : "calc(100vh - 196px)",
        }}
        srNumber={{
          clickable: true,
          events: "ORDERS_LOG",
        }}
        isCollapsable={true}
        tabName={""} // TAB URL
        PaginationCurrentPage={
          OrderManagmentFilter["PendingForStores"]?.CurrentPage
        } // TAB CURRENT PAGE
        PaginationFunction={currentFunction} // PAGINATION CHNAGE FUNCTION
        TableColumns={TableColumns} // TABLE COLLUMNS & ROWS
        OrderList={PendingForStoresList} // ORDER LIST
        Pagination={PendingForStoresList?.pagination} // CURRENT TAB PAGINATION
        EditAccess={
          selfInfo?.user?.user_type === "super_admin" ||
          PermissionsAccess?.OrderManagement[5]?.Edit
        } // EDITABLE ACCESS STATE
        APIcalling={""}
        isActionColumnAvailable={{
          isShow:
            selfInfo?.user?.user_type === "super_admin" ||
            PermissionsAccess?.OrderManagement[5]?.Edit,
          label: "add_remark_modal",
          naviagte: null,
        }}
        isActionTwoColumnAvailable={{
          isShow: false,
          url: "",
        }}
        isOdiFilterRowColorsAllow={true}
      />
    </section>
  );
};

export default FranchiseDispatch;
